import EfCollapseWinImg from '@elem/ui/ef-collapse-win-img';
import EfTitle from '@elem/ui/ef-title';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';

export default function TheComp() {
    const { t } = useLang('rapid.CollapseA');
    const { locale = 'us' } = useRouter();
    const IMG_MAP: any = {
        us: [
            'https://websiteoss.ecoflow.com/upload/image/1725420670057/us_Healthy%20Charging%20Mode_01.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1725420670533/us_Healthy%20Charging%20Mode_02.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1725420669842/us_Healthy%20Charging%20Mode_03.jpg',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/image/1725420569527/de_Healthy%20Charging%20Mode_01.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1725420569366/de_Healthy%20Charging%20Mode_02.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1725420568754/de_Healthy%20Charging%20Mode_03.jpg',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/image/1725420568912/fr_Healthy%20Charging%20Mode_01.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1725420570342/fr_Healthy%20Charging%20Mode_02.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1725420570122/fr_Healthy%20Charging%20Mode_03.jpg',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/image/1725420569091/es_Healthy%20Charging%20Mode_01.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1725420569929/es_Healthy%20Charging%20Mode_02.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1725420569719/es_Healthy%20Charging%20Mode_03.jpg',
        ],
        it: [
            'https://websiteoss.ecoflow.com/upload/image/1725420669486/it_Healthy%20Charging%20Mode_01.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1725420670257/it_Healthy%20Charging%20Mode_02.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1725420669607/it_Healthy%20Charging%20Mode_03.jpg',
        ],
        jp: [
            'https://websiteoss.ecoflow.com/upload/image/1730685786983/us_Healthy%20Charging%20Mode_01.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1730685787297/us_Healthy%20Charging%20Mode_02.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1730685787108/us_Healthy%20Charging%20Mode_03.jpg',
        ],
        kr: [
            'https://websiteoss.ecoflow.com/upload/image/1747989885607/8_1%20img.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1747989885451/8_2%20img.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1747989885847/8_3%20img.jpg',
        ],
    };
    const IMG = IMG_MAP[locale] || IMG_MAP.us;
    const listA = [
        {
            pc: IMG[0],
            title: t('a_title'),
            desc: t('a_desc'),
        },
        {
            pc: IMG[2],
            title: t('b_title'),
            desc: t('b_desc'),
        },
        {
            pc: IMG[1],
            title: t('c_title'),
            desc: t('c_desc'),
        },
    ];
    return (
        <div className={styles.comp}>
            <EfSpec />
            <EfTitle>{t('title')}</EfTitle>
            <EfCollapseWinImg position="imgL" list={listA} />
            <EfSpec />
        </div>
    );
}
